import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Progress, Button, Form, Row, Col, Spin, message } from 'antd';
import { setInitUrl } from 'redux/actions/Auth'
import RadioButtons from '../../components/Questions/RadioButtons'
import Checkboxes from '../../components/Questions/Checkboxes'
import { DataRequestAction, DataGetAction } from '../../redux/actions/http'
import { useHistory } from 'react-router-dom'

const Index = () => {

    const dispatch = useDispatch()
    const history = useHistory()
    const signupProps = useSelector(state => state.signUp)
    const surveyProps = useSelector(state => state.surveyR)
    const { questionsList } = signupProps
    const { savingDailyBaseLineLoader, savingDailyBaseLineSuccess, savingDailyBaseLineError } = surveyProps
    const { dailyBaseLine } = questionsList
    const [current, setCurrent] = useState(0);
    const [parentOfQuestion, setParentOfSubQuestion] = useState(-1);
    const [subQuestion, setShowSubQuestion] = useState(null);
    const [surveyResult, setSurvey] = useState(dailyBaseLine && dailyBaseLine.length ? dailyBaseLine : []);
    const [form] = Form.useForm();

    const fetchQuestionnaire = () => {
        dispatch(DataGetAction('getPatientQuestion', '', 'gettingPatientQuestion'));

    }
    useEffect(fetchQuestionnaire, [])



    const renderSingleQuestion = (data) => {

        if (data.questionType === "Radio") {
            return <RadioButtons data={data} />
        } else if (data.questionType === "Checkbox" || data.questionType === "CheckBox") {

            return <Checkboxes data={data} />
        } else if (data.questionType === "textBox") {

        }
    }

    const renderQuestions = () => {
        if (surveyResult && surveyResult.length) {
            console.log("==========renderQuestions", subQuestion, current);
            if (subQuestion) {
                return renderSingleQuestion(subQuestion)
            } else {
                return renderSingleQuestion(surveyResult[current])
            }
        }
    }


    const completeForm = () => {
        form.validateFields().then(data => {
            const selectedValue = Object.values(data)
            surveyResult[current]['selected'] = selectedValue
            setSurvey([...surveyResult]);
            setCurrent(0);
            setShowSubQuestion(null);
            setParentOfSubQuestion(-1)

            dispatch(DataRequestAction('PUT', 'updateDailyBaseLine', surveyResult, '', 'updatingDailyBaseLine'));
        }).catch(error => {
            console.log("========== error ======", error)
        })
    }


    if (savingDailyBaseLineError) {
        message.error("Some Error Occur While Saving Info.")
        dispatch({
            type: 'reset_survey'
        })
    }

    if (savingDailyBaseLineSuccess) {
        message.success("your information store successfully")

        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const token = localStorage.getItem('token')
        console.log("========= userInfo ======", userInfo);
        console.log("========= userInfo ======", userInfo);
        dispatch({
            type: 'setAuthToken',
            payload: token
        })
        if (userInfo.role === "client") {
            dispatch(setInitUrl('/client/dashboard'));
            history.push('/client/dashboard')
        }

        dispatch({
            type: 'show_daily_question_modal'
        })
        dispatch({
            type: 'reset_survey'
        })

    }

    const next = () => {
        form.validateFields().then(data => {
            if (parentOfQuestion === -1) {
                let selectedValue = Object.values(data)
                if (surveyResult[current].questionType === "CheckBox") {
                    selectedValue = selectedValue[0];
                }
                surveyResult[current]['selected'] = selectedValue
                setSurvey([...surveyResult]);
                let subQuestion = null

                if (surveyResult[current].questionOptionType === "With Image" && surveyResult[current].questionType === "Radio") {
                    subQuestion = surveyResult[current]['questionOptionImage'][parseInt(selectedValue[0])].subQuestion || null;
                } else if (surveyResult[current].questionOptionType === "Without Image" && surveyResult[current].questionType === "Radio") {
                    subQuestion = surveyResult[current]['questionOption'][parseInt(selectedValue[0])].subQuestion || null;
                }
                if (subQuestion) {
                    setShowSubQuestion(subQuestion);
                    setParentOfSubQuestion(current);
                } else {
                    setCurrent(current + 1);
                }

            } else {
                let selectedValue = Object.values(data);
                if (subQuestion.questionType === "CheckBox") {
                    selectedValue = selectedValue[0];
                }
                const parentSelectedOption = surveyResult[parentOfQuestion].selected;
                if (surveyResult[parentOfQuestion].questionOptionType === "With Image" && surveyResult[parentOfQuestion].questionType === "Radio") {
                    surveyResult[parentOfQuestion]['questionOptionImage'][parseInt(parentSelectedOption[0])].subQuestion['selected'] = [...selectedValue]
                } else if (surveyResult[parentOfQuestion].questionOptionType === "Without Image" && surveyResult[parentOfQuestion].questionType === "Radio") {
                    surveyResult[parentOfQuestion]['questionOption'][parseInt(parentSelectedOption[0])].subQuestion['selected'] = [...selectedValue]
                }

                setShowSubQuestion(null);
                setParentOfSubQuestion(-1)
                setCurrent(current + 1);
            }


        }).catch(error => {
            console.log("========== error ======", error)
        })
    };

    const prev = () => {

        setCurrent(current - 1);

    };

    return (
        <div className="steps-content gx-pb-5">
            <Form
                name="basic"
                form={form}
            >
                <Row className="gx-px-4 gx-pt-5">
                    <Col xl={24} md={24} xs={24} sm={24}>
                        {renderQuestions()}
                    </Col>
                </Row>
                <div className="footer gx-d-flex gx-px-4">
                    <Progress percent={((current / surveyResult.length) * 100).toFixed(0)} size="small" />
                    <div className="buttons">
                        <div className="steps-action">
                            {current > 0 && (
                                <Button className="gx-pt-0 gx-mb-0" style={{ margin: '0 8px' }} onClick={() => prev()}>
                                    Previous
                                </Button>
                            )}
                            {current < surveyResult.length - 1 && (
                                <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => next()}>
                                    Next
                                </Button>
                            )}
                            {current === surveyResult.length - 1 && (
                                !savingDailyBaseLineLoader ? <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => completeForm()}>
                                    Done
                                </Button> : <Spin><Button className="gx-pt-0 gx-mb-0" type="primary" disabled>
                                        Done
                                </Button> </Spin>
                            )}

                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )

}

export default Index
